import { createStateSelectorHook } from 'src/lib/sweetState';

import { GenerationStore } from '../store';

const useGenerationState = createStateSelectorHook(GenerationStore, ['lastGenerationResult']);

export const useIsLastGenerationId = (requestId) => {
  const { lastGenerationResult } = useGenerationState();

  return lastGenerationResult?.id === requestId;
};
